import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Participation } from '../entities/Participation.js';
import { Product } from '../entities/products.js';
import { UserStammdaten } from '../entities/stammdaten.js';
import { User } from '../entities/user.js';

@Entity()
export class ExportParticipation extends AdornisEntity {
  static override _class = 'ExportParticipation';

  static override resolveID(entity) {
    return entity._id;
  }

  static fieldBlacklist = [
    'user.roles',
    'user.isOnline',
    'user.ios_sub',
    'user.participations',
    'user.stripeCustomerID',
    'participation.product',
    'participation.timeslotID',
    'participation.beraterID',
    'participation.user',
    'product.reference',
    'product.prices.interval',
    'product.prices.intervalCount',
    'product.prices.stripeID',
    'product.prices.bundleID',
    'product.settings.productID',
    'product.settings.parentInstitutionID',
    'product.beraterAvailabilities',
    'product.participations',
    // /IDs?$/,
    /_class$/,
  ];

  @Field(type => ID) _id!: string;
  @Field(type => User) user: Maybe<User>;
  @Field(type => Participation) participation: Maybe<Participation>;
  @Field(type => Product) product: Maybe<Product>;
  @Field(type => UserStammdaten) stammdaten: Maybe<UserStammdaten>;
}
